import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import AuthContext from "../../contexts/AuthContext";
import { BASE_URL } from "../../config";

// @ts-ignore
//import logo from "../../assets/images/logo-light.svg";
import { toggleSidebarMobile } from "../../utils/sidebarUtils";

const handleSidebarItemClick = () => {
  const sidebar = document.querySelector(".account-sidebar.active");
  if (sidebar) {
    sidebar.classList.remove("active");
  }
};

export const Sidebar = () => {
  const authContext = useContext(AuthContext);
  const user = authContext?.user;
  return (
    <div className="account-sidebar">
      <div className="closeMobileSidebarButton" onClick={toggleSidebarMobile}>
        <i className="fas fa-times"></i>
      </div>
      <div className="inner">
        <div className="logo-wrapper">
          <img
            alt="hive-logo"
            className="logo"
            src={`${BASE_URL}uploads/logo-light.png`}
          />
        </div>

        <div className="sidebar-content">
          {/* Sidebar menu */}
          <ul className="items-wrapper">
            {/* Partner Role - Simplified Menu */}
            {user?.role === "partner" ? (
              <>
                <li>
                  <NavLink
                    onClick={handleSidebarItemClick}
                    to="/partner/orders"
                    className={({ isActive }) =>
                      `item ${isActive ? "active" : ""}`
                    }
                  >
                    <i className="fa-solid fa-list"></i>
                    <span>My Orders</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    onClick={handleSidebarItemClick}
                    to="/partner/change-password"
                    className={({ isActive }) =>
                      `item ${isActive ? "active" : ""}`
                    }
                  >
                    <i className="fa-solid fa-key"></i>
                    <span>Change Password</span>
                  </NavLink>
                </li>
              </>
            ) : (
              <>
                {/* Admin/Owner - Full Menu */}
                <li>
                  <NavLink
                    onClick={handleSidebarItemClick}
                    to="/account/dashboard"
                    className={({ isActive }) =>
                      `item ${isActive ? "active" : ""}`
                    }
                  >
                    <i className="fa-solid fa-house"></i>
                    <span>Dashboard</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    onClick={handleSidebarItemClick}
                    to="/account/products"
                    className={({ isActive }) =>
                      `item ${isActive ? "active" : ""}`
                    }
                  >
                    <i className="fa-solid fa-box"></i>
                    <span>Products</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    onClick={handleSidebarItemClick}
                    to="/account/coupons"
                    className={({ isActive }) =>
                      `item ${isActive ? "active" : ""}`
                    }
                  >
                    <i className="fa-solid fa-tag"></i>
                    <span>Coupons</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    onClick={handleSidebarItemClick}
                    to="/account/orders"
                    className={({ isActive }) =>
                      `item ${isActive ? "active" : ""}`
                    }
                  >
                    <i className="fa-solid fa-dolly"></i>
                    <span>Orders</span>
                  </NavLink>
                </li>
                {user?.role === "owner" && (
                  <li>
                    <NavLink
                      onClick={handleSidebarItemClick}
                      to="/admin/partnerships"
                      className={({ isActive }) =>
                        `item ${isActive ? "active" : ""}`
                      }
                    >
                      <i className="fa-solid fa-handshake"></i>
                      <span>Partnership Requests</span>
                    </NavLink>
                  </li>
                )}
                <li>
                  <NavLink
                    onClick={handleSidebarItemClick}
                    to="/admin/theme-files"
                    className={({ isActive }) =>
                      `item ${isActive ? "active" : ""}`
                    }
                  >
                    <i className="fa-solid fa-file-code"></i>
                    <span>Site Editor</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    onClick={handleSidebarItemClick}
                    to="/account/change-password"
                    className={({ isActive }) =>
                      `item ${isActive ? "active" : ""}`
                    }
                  >
                    <i className="fa-solid fa-key"></i>
                    <span>Change Password</span>
                  </NavLink>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};
